import React, { useState, useEffect, useRef, useCallback } from "react";
import eyeFill from "@iconify/icons-eva/eye-fill";
import eyeOffFill from "@iconify/icons-eva/eye-off-fill";
import ContentCopyIcon from "@material-ui/icons/FileCopy";
import { History as HistoryIcon } from "@material-ui/icons";
import {
  createTheme,
  ThemeProvider,
  experimentalStyled as styled,
} from "@material-ui/core/styles";
import { Icon } from "@iconify/react";
import {
  Card,
  CardContent,
  Typography,
  Grid,
  Table,
  TableRow,
  TableBody,
  TableCell,
  TableContainer,
  TablePagination,
  IconButton,
  Container,
  TextField,
  Stack,
  Fab,
  Button,
  Tooltip,
  Box,
  CircularProgress,
} from "@material-ui/core";
import * as locales from "@material-ui/core/locale";
import Scrollbar from "../Scrollbar";
import { TablaHead } from "../_dashboard/tablas";
import { filter } from "lodash";
import { makeStyles } from "@material-ui/styles";
import plusFill from "@iconify/icons-eva/plus-fill";
import VisibilityIcon from "@material-ui/icons/Visibility";
import { useNavigate } from "react-router-dom";
import { formatRut } from "@fdograph/rut-utilities";
import AgregarSocio from "src/components/gestionCliente/AgregarSocio";
import AgregarClavesPortales from "src/components/gestionCliente/AgregarClavesPortales";
import { useSelector } from "react-redux";
import { useSnackbar } from "src/components/snackbar";
import {
  clientesApi,
  useLazyGenerarUrlPrefirmadaPoderQuery,
} from "src/services/clientesApi";
import ModalHistorialAuditoriaClaves from "src/components/gestionCliente/ModalHistorialAuditoriaClaves";
import ModalAdvertenciaCopiaClave from "src/components/gestionCliente/ModalAdvertenciaCopiaClave";

const RootStyle = styled("div")(({ theme }) => ({
  marginTop: "1rem",
}));

const styles = makeStyles((theme) => ({
  root: {
    minWidth: 275,
  },
  title: {
    textAlign: "center",
    fontSize: "24px",
    marginBottom: "1rem",
    color: theme.palette.primary.main,
  },
  textfield: {
    width: "100%",
  },
  grid: {
    xs: 12,
    alignItems: "center",
    justify: "center",
    marginBottom: "1rem",
  },
  pos: {
    marginBottom: 12,
  },
  formControl: {
    minWidth: "100%",
    marginBottom: 12,
    marginTop: 12,
  },
}));

const TABLE_HEAD = [
  { id: "usuario", label: "Nombre Usuario", alignRight: false },
  { id: "clave", label: "Contraseña", alignRight: false },
  { id: "institucion", label: "Institución", alignRight: false },
];

const TABLE_HEAD2 = [
  { id: "rutSocio", label: "Rut Socio", alignRight: false },
  { id: "nombreSocio", label: "Nombre Socio", alignRight: false },
];

function descendingComparator(a, b, orderBy) {
  if (b[orderBy] < a[orderBy]) {
    return -1;
  }
  if (b[orderBy] > a[orderBy]) {
    return 1;
  }
  return 0;
}

function getComparator(order, orderBy) {
  return order === "desc"
    ? (a, b) => descendingComparator(a, b, orderBy)
    : (a, b) => -descendingComparator(a, b, orderBy);
}

function applySortFilter(array, comparator, query) {
  const stabilizedThis = array.map((el, index) => [el, index]);
  stabilizedThis.sort((a, b) => {
    const order = comparator(a[0], b[0]);
    if (order !== 0) return order;
    return a[1] - b[1];
  });
  if (query) {
    return filter(
      array,
      (_user) => _user.nombre.toLowerCase().indexOf(query.toLowerCase()) !== -1,
    );
  }
  return stabilizedThis.map((el) => el[0]);
}

export default function ClavesCliente(props) {
  const { tarea, setShowAlert, setColor, setMessage } = props;
  const [page, setPage] = useState(0);
  const [order, setOrder] = useState("asc");
  const [selected, setSelected] = useState([]);
  const [orderBy, setOrderBy] = useState("nombre");
  const [rowsPerPage, setRowsPerPage] = useState(10);
  const [locale] = useState("esES");
  const classes = styles();
  const [passwordsVisibles, setPasswordsVisibles] = useState({});
  const [passwordsDesencriptadas, setPasswordsDesencriptadas] = useState({});

  const [modalHistorialOpen, setModalHistorialOpen] = useState(false);
  const [claveSeleccionadaHistorial, setClaveSeleccionadaHistorial] =
    useState(null);

  const [dialogAdvertenciaOpen, setDialogAdvertenciaOpen] = useState(false);
  const [claveParaCopiar, setClaveParaCopiar] = useState(null);
  const [mostrarAdvertenciaCopia, setMostrarAdvertenciaCopia] = useState(true);

  const [cliente, setCliente] = useState(null);
  const [archivoObtenido, setArchivoObtenido] = useState(null);
  const [open, setOpen] = useState(false);
  const [sociosEmpresas, setSociosEmpresas] = useState([]);
  const [openAgregarSocio, setOpenAgregarSocio] = useState(false);
  const isMounted = useRef(true);
  const navigate = useNavigate();

  const { enqueueSnackbar } = useSnackbar();
  // Obtener rol del usuario logueado y sucursal activa
  const {
    rol: rolObtenido,
    sucursal: { refSucursal },
  } = useSelector((state) => state.auth.user);

  const rolUsuario = rolObtenido || "EMPLEADO";
  const puedeVerPassword = ["SUPER_ADMIN"].includes(rolUsuario);

  // Hook RTK Query para desencriptar claves
  const [desencriptarClave, { isLoading: isDesencriptando }] =
    clientesApi.useDesencriptarClaveMutation();
  const [generarUrlPrefirmadaPoder] = useLazyGenerarUrlPrefirmadaPoderQuery();

  // Hook RTK Query para obtener claves del cliente
  const {
    data: clavesPortales = [],
    isLoading: isLoadingClaves,
    isError: isErrorClaves,
  } = clientesApi.useObtenerClavesClienteQuery(
    { rut: tarea.refCliente },
    {
      skip: !tarea.refCliente, // No ejecutar si no hay refCliente
    },
  );

  const generarClaveUnica = (refCliente, institucion, usuario) => {
    return `${refCliente}-${institucion}-${usuario}`;
  };

  // Función auxiliar para copiar al portapapeles con limpieza automática
  const copiarAlPortapapeles = useCallback(
    async (password) => {
      try {
        await navigator.clipboard.writeText(password);

        enqueueSnackbar("Contraseña copiada (se limpiará en 45 segundos)", {
          variant: "success",
          anchorOrigin: {
            vertical: "bottom",
            horizontal: "right",
          },
        });

        // Limpiar portapapeles después de 45 segundos
        setTimeout(async () => {
          try {
            // Verificar que aún está la misma contraseña
            const current = await navigator.clipboard.readText();
            if (current === password) {
              await navigator.clipboard.writeText("");
              console.log("Portapapeles limpiado por seguridad");
            }
          } catch (error) {
            // Ignorar errores (el navegador puede no permitir leer el portapapeles)
            console.log(
              "No se pudo verificar/limpiar portapapeles:",
              error.message,
            );
          }
        }, 45000); // 45 segundos
      } catch (error) {
        enqueueSnackbar("Error al copiar la contraseña", {
          variant: "error",
          anchorOrigin: {
            vertical: "bottom",
            horizontal: "right",
          },
        });
      }
    },
    [enqueueSnackbar],
  );

  const ejecutarCopiaClave = useCallback(
    async (refCliente, institucion, usuario) => {
      const claveUnica = generarClaveUnica(refCliente, institucion, usuario);
      const passwordDesencriptada = passwordsDesencriptadas[claveUnica];

      if (passwordDesencriptada) {
        // Si ya tenemos la contraseña desencriptada en memoria, copiarla directamente
        await copiarAlPortapapeles(passwordDesencriptada);
      } else {
        // Si no está desencriptada, obtenerla del backend y copiar
        try {
          const resultado = await desencriptarClave({
            refCliente,
            institucion,
            usuario,
            refSucursal,
            accion: "COPIA",
          }).unwrap();

          // Copiar al portapapeles con limpieza automática
          await copiarAlPortapapeles(resultado.claveDesencriptada);

          // Solo guardar en memoria si el usuario tiene permisos para VER
          // Esto evita que usuarios sin permisos puedan ver la contraseña después de copiarla
          if (puedeVerPassword) {
            setPasswordsDesencriptadas((prev) => ({
              ...prev,
              [claveUnica]: resultado.claveDesencriptada,
            }));
          }
        } catch (error) {
          console.error("Error al copiar:", error);

          let mensaje = "Error al copiar la contraseña";
          if (error.status === 403) {
            mensaje = "No tienes permisos para acceder a esta contraseña";
          } else if (error.status === 404) {
            mensaje = "Contraseña no encontrada";
          }

          enqueueSnackbar(mensaje, {
            variant: "error",
            anchorOrigin: {
              vertical: "bottom",
              horizontal: "right",
            },
          });
        }
      }
    },
    [
      passwordsDesencriptadas,
      puedeVerPassword,
      desencriptarClave,
      enqueueSnackbar,
      refSucursal,
      copiarAlPortapapeles,
    ],
  );

  // Copiar contraseña al portapapeles
  const handleCopyPassword = useCallback(
    (refCliente, institucion, usuario) => {
      // Si es la primera vez en la sesión, mostrar advertencia
      if (mostrarAdvertenciaCopia) {
        setClaveParaCopiar({ refCliente, institucion, usuario });
        setDialogAdvertenciaOpen(true);
        return;
      }

      // Si ya vio la advertencia, ejecutar copia directamente
      ejecutarCopiaClave(refCliente, institucion, usuario);
    },
    [mostrarAdvertenciaCopia, ejecutarCopiaClave],
  );

  useEffect(() => {
    return () => {
      isMounted.current = false;
    };
  }, []);

  // Verificar si ya vio la advertencia de seguridad en esta sesión
  useEffect(() => {
    const yaVioAdvertencia = sessionStorage.getItem(
      "vio-advertencia-copia-claves",
    );
    if (yaVioAdvertencia) {
      setMostrarAdvertenciaCopia(false);
    }
  }, []);

  const { data: sociosData } = clientesApi.useGetSociosQuery(
    { rutCliente: tarea?.refCliente },
    { skip: !tarea?.refCliente },
  );

  const { data: clienteData } = clientesApi.useGetClienteQuery(
    { rut: tarea?.refCliente },
    { skip: !tarea?.refCliente },
  );

  useEffect(() => {
    if (sociosData && isMounted.current) {
      setSociosEmpresas(sociosData);
    }
  }, [sociosData]);

  useEffect(() => {
    if (clienteData && isMounted.current) {
      setCliente(clienteData);
    }
  }, [clienteData]);

  const { data: poderData } = clientesApi.useGetPoderClienteQuery(
    { rut: cliente?.rut, sucursal: refSucursal },
    { skip: !cliente?.rut || !refSucursal },
  );

  useEffect(() => {
    if (poderData && isMounted.current) {
      setArchivoObtenido(poderData[0] || null);
    }
  }, [poderData]);

  const handleRequestSort = (event, property) => {
    const isAsc = orderBy === property && order === "asc";
    setOrder(isAsc ? "desc" : "asc");
    setOrderBy(property);
  };

  const handleSelectAllClick = (event) => {
    if (event.target.checked) {
      const newSelecteds = clavesPortales.map((n) => n.name);
      setSelected(newSelecteds);
      return;
    }
    setSelected([]);
  };

  const handleChangePage = (event, newPage) => {
    setPage(newPage);
  };

  const handleChangeRowsPerPage = (event) => {
    setRowsPerPage(parseInt(event.target.value, 10));
    setPage(0);
  };

  const emptyRows =
    page > 0
      ? Math.max(0, (1 + page) * rowsPerPage - clavesPortales.length)
      : 0;

  const filteredUsers = applySortFilter(
    clavesPortales,
    getComparator(order, orderBy),
    "",
  );

  const isUserNotFound = filteredUsers.length === 0;

  // Manejar visualización de contraseña (solo ADMIN/SUPER_ADMIN)
  const handleTogglePassword = useCallback(
    async (refCliente, institucion, usuario, claveEncriptada) => {
      const claveUnica = generarClaveUnica(refCliente, institucion, usuario);

      // Si ya está visible, solo ocultarla
      if (passwordsVisibles[claveUnica]) {
        setPasswordsVisibles((prev) => ({
          ...prev,
          [claveUnica]: false,
        }));
        return;
      }

      // Si no está visible y no tenemos permisos, mostrar mensaje
      if (!puedeVerPassword) {
        enqueueSnackbar(
          "No tienes permisos para visualizar contraseñas. Solo usuarios SUPER_ADMIN pueden hacerlo.",
          {
            variant: "warning",
            anchorOrigin: {
              vertical: "bottom",
              horizontal: "right",
            },
          },
        );
        return;
      }

      // Si no está visible y tenemos permisos, desencriptar desde el backend
      try {
        const resultado = await desencriptarClave({
          refCliente,
          institucion,
          usuario,
          refSucursal,
          accion: "VISUALIZACION",
        }).unwrap();

        // Guardar la contraseña desencriptada
        setPasswordsDesencriptadas((prev) => ({
          ...prev,
          [claveUnica]: resultado.claveDesencriptada,
        }));

        // Marcar como visible
        setPasswordsVisibles((prev) => ({
          ...prev,
          [claveUnica]: true,
        }));

        // Mostrar advertencia si necesita migración
        if (resultado.necesitaMigracion) {
          enqueueSnackbar(
            "Esta clave está en formato antiguo. Se recomienda actualizarla.",
            {
              variant: "info",
              anchorOrigin: {
                vertical: "bottom",
                horizontal: "right",
              },
            },
          );
        }
      } catch (error) {
        console.error("Error al desencriptar:", error);

        let mensaje = "Error al obtener la contraseña";
        if (error.status === 403) {
          mensaje = "No tienes permisos para ver esta contraseña";
        } else if (error.status === 404) {
          mensaje = "Contraseña no encontrada";
        }

        enqueueSnackbar(mensaje, {
          variant: "error",
          anchorOrigin: {
            vertical: "bottom",
            horizontal: "right",
          },
        });
      }
    },
    [
      passwordsVisibles,
      puedeVerPassword,
      enqueueSnackbar,
      desencriptarClave,
      refSucursal,
    ],
  );

  // Abrir modal de historial de auditoría
  const handleOpenHistorial = useCallback(
    (refCliente, institucion, usuario) => {
      setClaveSeleccionadaHistorial({ refCliente, institucion, usuario });
      setModalHistorialOpen(true);
    },
    [],
  );

  // Cerrar modal de historial
  const handleCloseHistorial = useCallback(() => {
    setModalHistorialOpen(false);
    setClaveSeleccionadaHistorial(null);
  }, []);
  const descargarPoder = async () => {
    if (!archivoObtenido) return;

    if (archivoObtenido.s3key) {
      try {
        const result = await generarUrlPrefirmadaPoder({
          id: archivoObtenido.id,
          sucursal: refSucursal,
        }).unwrap();

        if (result && result.success) {
          window.open(result.data, "_blank");
        } else {
          enqueueSnackbar("Error al obtener el poder", { variant: "error" });
        }
      } catch (error) {
        console.error(error);
        enqueueSnackbar("Error al obtener el poder", { variant: "error" });
      }
    } else {
      window.open(archivoObtenido.urlPoder, "_blank");
    }
  };

  return (
    <Container>
      <RootStyle>
        {cliente && cliente.rut && (
          <Card
            className={classes.root}
            variant="outlined"
            sx={{ padding: "1rem" }}
          >
            <CardContent>
              <Stack spacing={2}>
                <Grid container>
                  <Grid item xs={2} md={2}>
                    <Typography variant="p">Poder</Typography>
                  </Grid>

                  <Grid item xs={10} md={10}>
                    {archivoObtenido ? (
                      <Grid
                        container
                        style={{ marginTop: "10px", marginBottom: "10px" }}
                      >
                        <Grid item xs={12} md={10}>
                          <Fab
                            style={{ width: "90%" }}
                            variant="extended"
                            size="medium"
                            color="primary"
                            aria-label="add"
                            onClick={descargarPoder}
                          >
                            DESCARGAR PODER
                          </Fab>
                        </Grid>
                      </Grid>
                    ) : (
                      <Typography variant="p">
                        No existe poder para descargar
                      </Typography>
                    )}
                  </Grid>
                </Grid>

                <Grid container spacing={2}>
                  <Grid item xs={12} md={12} lg={12}>
                    <TextField
                      value={cliente.rut}
                      label="Rut Cliente"
                      variant="outlined"
                      fullWidth
                      disabled
                    />
                  </Grid>
                  <Grid item xs={12} md={12} lg={12}>
                    <TextField
                      value={cliente.nombre}
                      label="Nombre Cliente"
                      variant="outlined"
                      multiline
                      rows={2}
                      fullWidth
                      disabled
                    />
                  </Grid>
                  <Grid item xs={12} md={6} lg={6}>
                    <TextField
                      value={cliente.correo}
                      label="Correo Cliente"
                      variant="outlined"
                      fullWidth
                      disabled
                    />
                  </Grid>

                  <Grid item xs={12} md={6} lg={6}>
                    <TextField
                      value={cliente.correoFacturacion}
                      label="Correo facturación"
                      variant="outlined"
                      error={cliente.correoFacturacion ? false : true}
                      helperText={
                        cliente.correoFacturacion
                          ? null
                          : "Falta correo de facturación"
                      }
                      fullWidth
                      disabled
                    />
                  </Grid>
                  <Grid item xs={12} md={6} lg={6}>
                    <TextField
                      value={cliente.contacto}
                      label="Contacto o Representante Legal"
                      variant="outlined"
                      fullWidth
                      disabled
                    />
                  </Grid>
                  <Grid item xs={12} md={6} lg={6}>
                    <TextField
                      value={cliente.telefono}
                      label="Teléfono Cliente"
                      variant="outlined"
                      fullWidth
                      disabled
                    />
                  </Grid>
                </Grid>
              </Stack>
            </CardContent>
          </Card>
        )}

        <Card className={classes.root} variant="outlined">
          <CardContent>
            <Grid container className={classes.grid}>
              <Grid item xs={12}>
                <Typography
                  variant="h5"
                  component="h2"
                  className={classes.title}
                >
                  Socios
                </Typography>
              </Grid>
              <Grid item xs={12} align="end">
                <Button
                  onClick={() => {
                    setOpenAgregarSocio(true);
                  }}
                  variant="contained"
                  startIcon={<Icon icon={plusFill} />}
                >
                  Agregar Socio
                </Button>
              </Grid>
            </Grid>

            <Scrollbar>
              <TableContainer sx={{ minWidth: 800 }}>
                <Table>
                  <TablaHead headLabel={TABLE_HEAD2} />
                  <TableBody>
                    {sociosEmpresas.map((row, idx) => {
                      const { rutCliente, nombreCliente } = row;

                      return (
                        <TableRow
                          hover
                          key={rutCliente + nombreCliente + idx}
                          tabIndex={-1}
                          role="checkbox"
                        >
                          <TableCell align="left">
                            {formatRut(rutCliente)}
                          </TableCell>
                          <TableCell align="left">{nombreCliente}</TableCell>
                          <TableCell align="left">
                            <Button
                              aria-label="delete"
                              onClick={() => {
                                navigate("/dashboard/clientes/" + rutCliente);
                              }}
                            >
                              <VisibilityIcon />
                            </Button>
                          </TableCell>
                        </TableRow>
                      );
                    })}
                  </TableBody>
                </Table>
              </TableContainer>
            </Scrollbar>
          </CardContent>
        </Card>

        <Card className={classes.root} variant="outlined">
          <CardContent>
            <Grid container className={classes.grid}>
              <Grid item xs={12}>
                <Typography
                  variant="h5"
                  component="h2"
                  className={classes.title}
                >
                  Claves Portales
                </Typography>
              </Grid>
              <Grid item xs={12} align="end">
                <Button
                  onClick={() => {
                    setOpen(true);
                  }}
                  variant="contained"
                  startIcon={<Icon icon={plusFill} />}
                  disabled={isLoadingClaves}
                >
                  Agregar Claves
                </Button>
              </Grid>
            </Grid>

            <Scrollbar>
              <TableContainer sx={{ minWidth: 800 }}>
                <Table>
                  <TablaHead
                    order={order}
                    orderBy={orderBy}
                    headLabel={TABLE_HEAD}
                    rowCount={clavesPortales.length}
                    numSelected={selected.length}
                    onRequestSort={handleRequestSort}
                    onSelectAllClick={handleSelectAllClick}
                  />

                  <TableBody>
                    {/* Estado de carga */}
                    {isLoadingClaves && (
                      <TableRow>
                        <TableCell align="center" colSpan={3} sx={{ py: 3 }}>
                          <CircularProgress size={24} />
                          <Typography
                            variant="body2"
                            color="textSecondary"
                            style={{ marginTop: 8 }}
                          >
                            Cargando claves...
                          </Typography>
                        </TableCell>
                      </TableRow>
                    )}

                    {/* Estado de error */}
                    {isErrorClaves && (
                      <TableRow>
                        <TableCell align="center" colSpan={3} sx={{ py: 3 }}>
                          <Typography variant="body2" color="error">
                            Error al cargar las claves. Intenta recargar la
                            página.
                          </Typography>
                        </TableCell>
                      </TableRow>
                    )}

                    {/* Datos de la tabla */}
                    {!isLoadingClaves &&
                      !isErrorClaves &&
                      filteredUsers &&
                      filteredUsers
                        .slice(
                          page * rowsPerPage,
                          page * rowsPerPage + rowsPerPage,
                        )
                        .map((row) => {
                          const {
                            usuario,
                            clave: claveEncriptada,
                            institucion,
                          } = row;
                          const isItemSelected =
                            selected.indexOf(usuario) !== -1;

                          // Generar clave única para esta fila
                          const claveUnica = generarClaveUnica(
                            tarea.refCliente,
                            institucion,
                            usuario,
                          );

                          //  Verificar si esta contraseña está visible
                          const esVisible = passwordsVisibles[claveUnica];
                          const passwordDesencriptada =
                            passwordsDesencriptadas[claveUnica];

                          return (
                            <TableRow
                              hover
                              key={claveUnica}
                              tabIndex={-1}
                              role="checkbox"
                              selected={isItemSelected}
                              aria-checked={isItemSelected}
                            >
                              {/* Columna 1: Usuario */}
                              <TableCell align="left">{usuario}</TableCell>

                              {/* Columna 2: Contraseña con botones de acción */}
                              <TableCell align="left">
                                <Grid
                                  container
                                  direction="row"
                                  alignItems="center"
                                  spacing={1}
                                >
                                  {/* Mostrar contraseña (visible u oculta) */}
                                  <Grid item style={{ minWidth: 120 }}>
                                    {esVisible && passwordDesencriptada ? (
                                      <Typography
                                        variant="body2"
                                        style={{
                                          fontFamily: "monospace",
                                          fontSize: 14,
                                        }}
                                      >
                                        {passwordDesencriptada}
                                      </Typography>
                                    ) : (
                                      <Typography variant="body2">
                                        ••••••••••••
                                      </Typography>
                                    )}
                                  </Grid>

                                  {/* Botón: Ver/Ocultar contraseña (solo SUPER_ADMIN) */}
                                  {puedeVerPassword && (
                                    <Grid item>
                                      <Tooltip
                                        title={
                                          !puedeVerPassword
                                            ? "Solo SUPER_ADMIN puede visualizar contraseñas"
                                            : esVisible
                                              ? "Ocultar contraseña"
                                              : "Ver contraseña"
                                        }
                                      >
                                        <IconButton
                                          onClick={() =>
                                            handleTogglePassword(
                                              tarea.refCliente,
                                              institucion,
                                              usuario,
                                              claveEncriptada,
                                            )
                                          }
                                          size="small"
                                          disabled={isDesencriptando}
                                        >
                                          <Icon
                                            icon={
                                              esVisible ? eyeFill : eyeOffFill
                                            }
                                            width={20}
                                            height={20}
                                          />
                                        </IconButton>
                                      </Tooltip>
                                    </Grid>
                                  )}

                                  {/* Botón: Copiar al portapapeles (TODOS) */}
                                  <Grid item>
                                    <Tooltip title="Copiar al portapapeles">
                                      <IconButton
                                        onClick={() =>
                                          handleCopyPassword(
                                            tarea.refCliente,
                                            institucion,
                                            usuario,
                                          )
                                        }
                                        size="small"
                                        disabled={isDesencriptando}
                                      >
                                        <ContentCopyIcon
                                          fontSize="small"
                                          style={{ width: 20, height: 20 }}
                                        />
                                      </IconButton>
                                    </Tooltip>
                                  </Grid>

                                  {/* Botón: Ver historial (solo ADMIN/SUPER_ADMIN) */}
                                  {puedeVerPassword && (
                                    <Grid item>
                                      <Tooltip title="Ver historial de accesos">
                                        <IconButton
                                          onClick={() =>
                                            handleOpenHistorial(
                                              tarea.refCliente,
                                              institucion,
                                              usuario,
                                            )
                                          }
                                          size="small"
                                        >
                                          <HistoryIcon
                                            fontSize="small"
                                            style={{ width: 20, height: 20 }}
                                          />
                                        </IconButton>
                                      </Tooltip>
                                    </Grid>
                                  )}
                                </Grid>
                              </TableCell>

                              {/* Columna 3: Institución */}
                              <TableCell align="left">{institucion}</TableCell>
                            </TableRow>
                          );
                        })}
                    {emptyRows > 0 && (
                      <TableRow style={{ height: 53 * emptyRows }}>
                        <TableCell colSpan={6} />
                      </TableRow>
                    )}
                    {/* Filas vacías para mantener altura de tabla */}
                    {!isLoadingClaves && !isErrorClaves && emptyRows > 0 && (
                      <TableRow style={{ height: 53 * emptyRows }}>
                        <TableCell colSpan={3} />
                      </TableRow>
                    )}
                  </TableBody>
                  {!isLoadingClaves && !isErrorClaves && isUserNotFound && (
                    <TableBody>
                      <TableRow>
                        <TableCell align="center" colSpan={3} sx={{ py: 3 }}>
                          <Typography variant="body2" color="textSecondary">
                            No hay claves registradas para este cliente.
                          </Typography>
                        </TableCell>
                      </TableRow>
                    </TableBody>
                  )}
                </Table>
              </TableContainer>
            </Scrollbar>
            {/* Mensaje informativo sobre permisos */}
            {!isLoadingClaves &&
              !puedeVerPassword &&
              clavesPortales.length > 0 && (
                <Box mt={2} mb={1}>
                  <Typography variant="caption" color="textSecondary">
                    Solo usuarios SUPER_ADMIN pueden visualizar contraseñas.
                    Puedes copiar contraseñas usando el botón 📋.
                  </Typography>
                </Box>
              )}
            <ThemeProvider
              theme={(outerTheme) => createTheme(outerTheme, locales[locale])}
            >
              <TablePagination
                rowsPerPageOptions={[10, 25, 50]}
                component="div"
                count={clavesPortales.length}
                rowsPerPage={rowsPerPage}
                page={page}
                onPageChange={handleChangePage}
                onRowsPerPageChange={handleChangeRowsPerPage}
              />
            </ThemeProvider>
          </CardContent>
        </Card>
        {openAgregarSocio && (
          <AgregarSocio
            open={openAgregarSocio}
            setOpen={setOpenAgregarSocio}
            setSocios={setSociosEmpresas}
            refCliente={tarea.refCliente}
            setShowMessage={setShowAlert}
            setColor={setColor}
            setMessage={setMessage}
          />
        )}

        {open && (
          <AgregarClavesPortales
            open={open}
            setOpen={setOpen}
            refCliente={tarea.refCliente}
          />
        )}

        {modalHistorialOpen && claveSeleccionadaHistorial && (
          <ModalHistorialAuditoriaClaves
            open={modalHistorialOpen}
            onClose={handleCloseHistorial}
            refCliente={claveSeleccionadaHistorial.refCliente}
            institucion={claveSeleccionadaHistorial.institucion}
            usuario={claveSeleccionadaHistorial.usuario}
            refSucursal={refSucursal}
          />
        )}

        <ModalAdvertenciaCopiaClave
          open={dialogAdvertenciaOpen}
          onClose={() => {
            setDialogAdvertenciaOpen(false);
            setClaveParaCopiar(null);
          }}
          onConfirm={() => {
            // Cerrar modal y marcar que ya vio la advertencia
            setDialogAdvertenciaOpen(false);
            setMostrarAdvertenciaCopia(false);
            sessionStorage.setItem("vio-advertencia-copia-claves", "true");

            // Ejecutar la copia directamente (sin pasar por handleCopyPassword)
            if (claveParaCopiar) {
              ejecutarCopiaClave(
                claveParaCopiar.refCliente,
                claveParaCopiar.institucion,
                claveParaCopiar.usuario,
              );
              setClaveParaCopiar(null);
            }
          }}
        />
      </RootStyle>
    </Container>
  );
}
